export default __webpack_public_path__ + "static/media/setTime.410f7f72.svg";